import {
    Button,
    FormGroup,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Textarea,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const NoteModal = ({ invoice, open, onClose }) => {
    const { auth } = usePage().props;

    const { data, setData, post, errors } = useForm({
        subject: `Factuur ${invoice.number}`,
        action: '',
        user_id: auth?.user?.id,
        label: 'Facturatie',
        customer_id: invoice.customer_id,
        customer_entity_id: invoice.customer_entity_id,
        invoice_id: invoice.id,
    });

    const handleSubmit = () => {
        post('/notes', {
            preserveScroll: true,
            preserveState: true,
            preserveUrl: true,
            replace: true,
            onSuccess: () => onClose(),
        });
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalHeader>{`Notitie maken voor Factuur ${invoice.number}`}</ModalHeader>
            <ModalContent>
                <FormGroup>
                    <Input
                        label='Onderwerp'
                        required
                        value={data?.subject || ''}
                        onChange={event =>
                            setData('subject', event.target.value)
                        }
                        error={errors?.subject}
                    />
                    <Textarea
                        label='Notitie'
                        required
                        value={data?.action || ''}
                        onChange={event =>
                            setData('action', event.target.value)
                        }
                        error={errors?.action}
                    />
                </FormGroup>
            </ModalContent>
            <ModalActions>
                <Button type='button' onClick={onClose}>
                    Annuleren
                </Button>
                <Button variant='primary' type='submit' onClick={handleSubmit}>
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default NoteModal;
